export default "__VITE_ASSET__gvN40VSL__"